// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__Te-D1","copyright":"Footer_copyright__XxBx2","parent":"Footer_parent__foXy3","Menu":"Footer_Menu__a76kA","Logo":"Footer_Logo__Ev4n1"};